export type InstanceCompetitionStatusTone = 'draft' | 'ready' | 'joined' | 'queued' | 'assigned'

export function getInstanceCompetitionStatus(instance: {
  play_mode?: string | null
  is_complete?: boolean | null
  league_count?: number | null
  league_id?: string | null
  lobby_assignment_status?: string | null
}): { tone: InstanceCompetitionStatusTone; label: string } {
  if (instance.is_complete !== true) {
    return { tone: 'draft', label: 'Draft team' }
  }

  if (instance.play_mode === 'cash') {
    if (instance.lobby_assignment_status === 'assigned') {
      return { tone: 'assigned', label: 'Lobby assigned' }
    }
    if (instance.lobby_assignment_status === 'queued') {
      return { tone: 'queued', label: 'Waiting list joined' }
    }
    return { tone: 'ready', label: 'Entry not selected' }
  }

  if (instance.play_mode === 'token') {
    const count = instance.league_count ?? (instance.league_id ? 1 : 0)
    if (count > 0) {
      return { tone: 'joined', label: `${count} league${count === 1 ? '' : 's'} joined` }
    }
    return { tone: 'ready', label: 'No leagues joined' }
  }

  return { tone: 'ready', label: 'Complete' }
}
